<template>
  <div class="mian_c">
    <div class="fixed">
      <div class="top_header">
        <div class="m_flex_box flex_vc flex_jz">
          <div class="m_flex_box flex_vc">
            <van-icon
              name="arrow-left"
              class="mar_r"
              @click="goback"
              size="0.4rem"
            />
          </div>
          <div
            style="text-align: center; font-size: 0.35rem; margin-left: -0.2rem"
          >
            提前还款计算器
          </div>
          <div></div>
        </div>
      </div>
    </div>
    <div class="fixed_pad"></div>
    <div class="intermediate">
      <div>
        <van-cell-group inset>
          <van-field
            v-model="value1"
            label="原贷款类型"
            placeholder="请选择原贷款类型"
            readonly
            clickable
            @click="repaymentType = true"
          >
          </van-field>
          <van-popup v-model="repaymentType" position="bottom">
            <van-picker
              show-toolbar
              :columns="typeList"
              @confirm="repaymentTypeConfirm"
              @cancel="repaymentType = false"
            />
          </van-popup>
          <van-field
            v-model="value2"
            label="原还款方式"
            placeholder="请选择原还款方式"
            readonly
            clickable
            @click="repaymentMode = true"
          >
          </van-field>
          <van-popup v-model="repaymentMode" position="bottom">
            <van-picker
              show-toolbar
              :columns="modeList"
              @confirm="repaymentModeConfirm"
              @cancel="repaymentMode = false"
            />
          </van-popup>
          <van-field
            v-model="value3"
            label="原商贷金额"
            placeholder="请输入原商贷金额"
          >
            <template #button>
              <div class="b_pad">万</div>
            </template>
          </van-field>

          <van-field
            v-model="value4"
            label="原商贷年限"
            placeholder="请选择原商贷年限"
            readonly
            clickable
            @click="originalYear = true"
          >
          </van-field>
          <van-popup v-model="originalYear" position="bottom">
            <van-picker
              show-toolbar
              :columns="yearsList"
              @confirm="originalYearConfirm"
              @cancel="originalYear = false"
            />
          </van-popup>

          <van-field
            v-model="value5"
            label="首次还款时间"
            placeholder="请选择首次还款时间"
            readonly
            clickable
            @click="firstTime = true"
          >
          </van-field>
          <van-popup v-model="firstTime" position="bottom">
            <van-datetime-picker
              v-model="currentDate"
              type="year-month"
              title="选择年月"
              :min-date="startMinDate"
              :max-date="startMaxDate"
              @confirm="firstTimeConfirm"
              @cancel="firstTime = false"
            />
          </van-popup>
          <van-field
            v-model="value6"
            label="原商贷利率"
            placeholder="请选择原商贷利率"
            readonly
            clickable
            @click="interestRate = true"
          >
          </van-field>
          <van-popup v-model="interestRate" position="bottom">
            <van-picker
              show-toolbar
              title="标题"
              :columns="columns"
              @confirm="interestRateConfirm"
              @cancel="interestRate = false"
            >
            </van-picker>
            <div style="padding: 0 20%">
              <van-field
                v-model="custom"
                label="自定义倍数"
                placeholder="请输入"
              >
                <template #button>
                  <div class="b_pad">倍</div>
                </template>
              </van-field>
            </div>
          </van-popup>
        </van-cell-group>
      </div>
      <div style="border-top: 10px solid #e5e5e5">
        <van-field
          v-model="value7"
          label="提前还款时间"
          placeholder="请选择提前还款时间"
          readonly
          clickable
          @click="advanceYear = true"
        />
        <van-popup v-model="advanceYear" position="bottom">
          <van-datetime-picker
              type="year-month"
              title="选择年月"
              :min-date="startMinDate"
              :max-date="startMaxDate"
              @confirm="advanceYearConfirm"
              @cancel="advanceYear = false"
            />
        </van-popup>
        <van-field
          v-model="value8"
          label="提前还款方式"
          placeholder="请选择提前还款方式"
          readonly
          clickable
          @click="advanceType = true"
        />
        <van-popup v-model="advanceType" position="bottom">
          <van-picker
            show-toolbar
            :columns="advanceTypeList"
            @confirm="advanceTypeConfirm"
            @cancel="advanceType = false"
          />
        </van-popup>
        <van-field
          v-model="value9"
          label="提前还款金额"
          placeholder="请输入提前还款金额"
        >
          <template #button>
            <div class="b_pad">万</div>
          </template>
        </van-field>
      </div>
      <div class="btn">
        <p>开始计算</p>
      </div>
    </div>
  </div>
</template>
<script>
import appHeader from "@/components/appHeader";
export default {
  data() {
    return {
      value1: "",
      value2: "",
      value3: "",
      value4: "",
      value5: "",
      value6: "",
      value7: "",
      value8: "",
      value9: "",
      custom:"",
      repaymentType: false,
      repaymentMode: false,
      originalYear: false,
      firstTime: false,
      interestRate: false, //原商贷利率
      advanceYear:false,
      advanceType:false,
      typeList: ["商业贷款", "公积金贷款"],
      modeList: ["等额本息", "等额本金"],
      yearsList: [
        "1年",
        "2年",
        "3年",
        "4年",
        "5年",
        "6年",
        "7年",
        "8年",
        "9年",
        "10年",
        "11年",
        "12年",
        "13年",
        "14年",
        "15年",
        "16年",
        "17年",
        "18年",
        "19年",
        "20年",
        "21年",
        "22年",
        "23年",
        "24年",
        "25年",
        "26年",
        "27年",
        "28年",
        "29年",
        "30年",
      ],
      startMinDate: new Date(1970, 1, 1),
      startMaxDate: new Date(),
      currentDate: new Date(),
      columns: [
        // 第一列
        {
          values: ["周一", "周二", "周三", "周四", "周五"],
          defaultIndex: 2,
        },
        // 第二列
        {
          values: [
            "上浮20%",
            "上浮15%",
            " 上浮10%",
            " 无折扣",
            "95折",
            "9折",
            "85折",
          ],
          defaultIndex: 1,
        },
      ],
      advanceTypeList:["一次性还清", "部分还清"]
    };
  },
  components: {
    appHeader,
  },
  methods: {
    goback() {
      this.$router.go(-1);
    },
    //原贷款类型确认
    repaymentTypeConfirm(value) {
      this.value1 = value;
      this.repaymentType = false;
    },
    //原还款方式确认
    repaymentModeConfirm(value) {
      this.value2 = value;
      this.repaymentMode = false;
    },
    //原商贷年限确认
    originalYearConfirm(value) {
      this.value4 = value;
      this.originalYear = false;
    },
    //首次还款时间确认
    firstTimeConfirm(value) {
      this.firstTime = false;
    },
    //原商贷利率确认
    interestRateConfirm(value){
      this.interestRate=false
    },
    //提前还款方式确认
    advanceTypeConfirm(value){

    },
    advanceYearConfirm(value){
      this.advanceYear = false;
    },
    yearsConfirm(value) {},
    changeTab(type) {
      this.tab = type;
    },
  },
};
</script>
 <style lang="less" scoped>
.fixed_pad {
  padding-top: 1.1rem;
}
.top_header {
  height: 0.5rem;
  padding: 0.2rem 0rem;
  width: 7.04rem;
  margin: 0 auto;
}
.fixed {
  border-bottom: 1px solid #f5f5f5;
  background-color: #fff;
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  z-index: 9;
  .top_normal {
    height: 100%;
    i {
      font-size: 0.32rem;
    }
  }
}
.btn {
  margin-top: 1rem;
  padding: 0 2rem;
  p {
    border-radius: 5px;
    text-align: center;
    padding: 10px 0;
    background: #007fff;
    color: #fff;
  }
}
.row_t {
  text-align: center;
  margin: 0.6rem 0;
  background: #ccffff;
  display: flex;
  padding: 20px 10px;
  justify-content: center;
  align-items: center;
  p {
    padding: 0.1rem 0;
    color: #fff;
    border-radius: 5px;
    background: #007fff;
    flex: 2;
  }
  div {
    flex: 7;
  }
}
.wra_block {
  border-radius: 5px;
  width: 4.5rem;
  height: 6rem;
  color: #000;
  background: #fff;
  padding: 0.2rem 0.3rem;
  .block_tit {
    padding: 0.2rem 0;
    font-size: 0.3rem;
    font-weight: 900;
  }
  .block_btn {
    margin-top: 0.8rem;
    padding: 0 1.5rem;
    p {
      padding: 0.1rem 0;
      background: #007fff;
      border-radius: 5px;
      text-align: center;
      color: #fff;
    }
  }
}
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.mian_c {
  padding: 0 0.1rem;
}
.intermediate {
  // padding: 0 0.3rem;
  .row_f {
    padding: 10px 16px;
    border-bottom: 1px solid #e5e5e5;
  }
  .accumulation {
    border-top: 10px solid #e5e5e5;
    border-bottom: 10px solid #e5e5e5;
  }
  .b_pad {
    padding-right: 0.5rem;
  }
}
.tab_con {
  padding-bottom: 0.5rem;
  border-bottom: 2px solid #e5e5e5;
  display: flex;
  height: 1rem;
  background-color: #fff;
  z-index: 9;
  span {
    text-align: center;
    flex: 1;
    font-weight: 800;
    font-size: 0.25rem;
    margin: 0.3rem;
    position: relative;
  }
  .active {
    color: #3072f5;
    font-size: 0.3rem;
    &:after {
      content: "";
      bottom: -0.2rem;
      position: absolute;
      display: block;
      left: 50%;
      transform: translateX(-50%);
      background-color: #3072f5;
      width: 1.1rem;
      height: 0.04rem;
    }
  }
}
</style>